import React from "react";
import { useNavigate } from "react-router-dom";

function BraidCard({ braid }) {
  const navigate = useNavigate();

  return (
    <div className="braid-card">
      <img
        src={braid.images[0]}
        alt={braid.name}
        className="braid-card-image"
      />

      <div className="braid-card-content">
        <h2>{braid.name}</h2>

        <p className="price">
          Starting at ${braid.basePrice}
        </p>

        <button
          onClick={() => navigate(`/braids/${braid.id}`)}
          className="button"
        >
          View Style
        </button>
      </div>
    </div>
  );
}

export default BraidCard;